<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="countries">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          v-if="canAddItem"
          @click="addNewData"
        >
          {{ $t("AddNew") }}
        </vs-button>

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
              -
              {{ countries.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : countries.length }}
              / {{ countries.length }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4"><span>4</span></vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10"><span>10</span></vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15"><span>15</span></vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20"><span>20</span></vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="NameAr">{{ $t("Country") }}</vs-th>
        <vs-th sort-key="Code">{{ $t("Code") }}</vs-th>
        <vs-th sort-key="IsActive">{{ $t("Status") }}</vs-th>
        <vs-th v-if="canManageItem">{{ $t("Actions") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click="editData(tr)">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ currentLang === "ar" ? (tr.NameAr || "-") : (tr.NameEn || "-") }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.Code || "-" }}</p>
            </vs-td>

            <vs-td>
              <vs-chip :color="tr.IsActive ? 'success' : 'danger'">
                {{ tr.IsActive ? $t("Active") : $t("Inactive") }}
              </vs-chip>
            </vs-td>

            <vs-td v-if="canManageItem" class="whitespace-no-wrap" @click.stop>
              <div class="icon-container">
                <vx-tooltip :text="$t('Edit')" position="top">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary cursor-pointer"
                    class="mr-3"
                    @click.stop="editData(tr)"
                  />
                </vx-tooltip>

                <vx-tooltip :text="$t('Delete')" position="top">
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger cursor-pointer"
                    @click.stop="openConfirm(tr)"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moduleCountry from "@/store/settings/Country/moduleCountry.js";
import DataViewSidebar from "./DataViewSidebar.vue";
import { canAdd, canEdit, canDelete } from "@/utils/permissions";

export default {
  components: {
    DataViewSidebar
  },
  data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: null
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted && this.$refs.table) return this.$refs.table.currentx;
      return 1;
    },
    currentLang() {
      return localStorage.getItem("SaveLang") || "en";
    },
    countries() {
      return this.$store.state.countryList.countries || [];
    },
    canAddItem() {
      return canAdd();
    },
    canManageItem() {
      return canEdit() || canDelete();
    }
  },
  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      if (!this.canManageItem) return;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("DeleteConfirmText"),
        accept: this.acceptAlert,
        acceptText: this.$t("Delete"),
        cancelText: this.$t("Cancel")
      });
    },
    acceptAlert() {
      this.deleteData(this.rowDataForDelete);
    },
    deleteData(data) {
      this.$store.dispatch("countryList/removeItem", data)
        .then(() => {
          this.$store.dispatch("countryList/fetchDataListItems");
          this.$vs.notify({
            time: 5000,
            color: "success",
            title: this.$t("Success"),
            text: this.$t("DeletedSuccessfully")
          });
        })
        .catch((err) => {
          let errorMessage = this.$t("Error");
          if (err && err.response && err.response.data && err.response.data.Message) {
            errorMessage = err.response.data.Message;
          }

          this.$vs.dialog({
            type: "alert",
            color: "danger",
            title: this.$t("Error"),
            text: errorMessage,
            acceptText: "OK"
          });

          this.$store.dispatch("countryList/fetchDataListItems");
        });
    }
  },
  created() {
    if (!moduleCountry.isRegistered) {
      this.$store.registerModule("countryList", moduleCountry);
      moduleCountry.isRegistered = true;
    }
    this.$store.dispatch("countryList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
  beforeDestroy() {
    if (this.$store && this.$store.state.countryList) {
      this.$store.unregisterModule("countryList");
      moduleCountry.isRegistered = false;
    }
  }
};
</script>

<style lang="scss">
.icon-container {
  display: flex;
}

#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
}
</style>
